/**
 * Created by henian.xu on 2020/3/31.
 *
 */

import { get, post } from 'api/request';

// 待申请列表
export function waitApplySubsidyList() {
    return get(this.url);
}
export function applyDetail(id) {
    return get(this.url, { id });
}
export function applyMaterialsDetail({ subsidyApplyId, applyMaterialsId }) {
    return get(this.url, {
        subsidyApplyId,
        applyMaterialsId,
    });
}

/**
 * 保存材料
 * @param subsidyApplyId
 * @param applyMaterialsId
 * @param applyMaterialsValue       json 串
 * @returns {Promise<*>}
 */
export function saveApplyMaterials({ subsidyApplyId, applyMaterialsId, applyMaterialsValue }) {
    return post(this.url, {
        subsidyApplyId,
        applyMaterialsId,
        applyMaterialsValue,
    });
}
export function submitAudit({
    companyName,
    workRegionId,
    subsidyApplyId,
    memberMsg,
    subsidyApplyType,
    signature,
    subsidyBankCard,
    bankAccount,
    openingBank,
}) {
    return post(this.url, {
        companyName,
        workRegionId,
        subsidyApplyId,
        memberMsg,
        subsidyApplyType,
        signature,
        subsidyBankCard,
        bankAccount,
        openingBank,
    });
}

// 公司选择 分页
export function companySelect({ keywords, currentPage, pageSize }) {
    return get(this.url, {
        keywords,
        currentPage,
        pageSize,
    });
}
